import { CASHFREE_DOC_OVER_VIEW } from "../../constants/Url";

export const defaultFaqTabs = [
  {
    id: 0,
    heading: "For Merchants",
    content: "Using Cashfree Payments for my businesss",
    icon: "merchant",
  },
  {
    id: 1,
    heading: "For Customer",
    content: "I recently paid online via Cashfree Payments",
    icon: "customer",
  },
];

export const defaultSupportLink = CASHFREE_DOC_OVER_VIEW;
